<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getDesignWorldCalendarTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionDesignWorldCalendar && permissionDesignWorldCalendar.permission_id === permission.readWrite"
          @click.native="createDesignWorldCalendarData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable(header.name)">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_date == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_date == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tr v-for="(item,index) in dataTable">
            <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td width="30%">{{item.name_en}}</td>
            <td width="25%">{{item.location}}</td>
            <td width="15%">{{item.event_date | moment('DD-MM-YYYY')}}</td>
            <td width="15%">{{item.end_event_date | moment('DD-MM-YYYY')}}</td>
            <td width="15%">{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showDesignWorldCalendarData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          <tbody>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import InputSearch from "../../components/Input/InputSearch";
    import CircleButton from "../../components/Button/CircleButton";
    import IconPencil from "../../components/Icon/icon-pencil";
    import Paginate from "../../components/Layout/Paginate";
    import {permissionDesignWorldCalendar, role} from "../../util/Permission";
    import {mapState} from "vuex";
    import Loading from 'vue-loading-overlay';
    import Swal from "sweetalert";
    export default {
        name: "DesignWorldCalendarTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch, Loading},
      computed: {
        permissionDesignWorldCalendar,
      },
      data() {
        return {
          title: "Design world calendar",
          isLoading: false,
          headers: [
            { id: 1, text: "No.",icon : null, name: null},
            { id: 2, text: "Title",icon : null, name: null},
            { id: 3, text: "Location",icon : null, name: null},
            { id: 4, text: "Start date",icon : true, name: "event_date"},
            { id: 5, text: "End date",icon : true, name: "end_event_date"},
            { id: 6, text: "Update date" ,icon : true, name: "updated_at"},
            { id: 7, text: "Edit" ,icon : null, name: null}
          ],
          dataTable: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          },
          permission : null,
          search : '',
          sort_date : 'desc',
          sort_column : null,
        };
      },
      created() {
          this.permission = role;
          this.getDesignWorldCalendarTable(1);
      },
      methods:{
        getDesignWorldCalendarTable(page){
          this.isLoading = true;
          this.$store.dispatch("DesignWorldCalendar/getDesignWorldCalendar",{
            page,
            search : this.search,
            sort_date : this.sort_date,
            sort_column : this.sort_column
          }).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot get Design world calendar data','error');
            this.isLoading = false;
          });
        },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getDesignWorldCalendarTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToDesignWorldCalendarEdit(){
          this.$router.push("/design-world-calendar/edit");
        },
        showDesignWorldCalendarData(id){
          this.isLoading = true;
          this.$store.dispatch("DesignWorldCalendar/showDesignWorldCalendar",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("DesignWorldCalendar/setFormDesignWorldCalendar",res.result).then(()=>{
                this.goToDesignWorldCalendarEdit();
              })
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot get Design world calendar data','error');
            this.isLoading = false;
          });
        },
        createDesignWorldCalendarData(){
          this.$store.dispatch("DesignWorldCalendar/clearFormData").then(()=>{
            this.goToDesignWorldCalendarEdit();
          })
        },
        searchInput(val){
          this.search = val;
        },
        sortDataTable(val){
          this.sort_column = val ? val : '';
          this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
          this.getDesignWorldCalendarTable(1);
        }
      }
    }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
